import moment from 'moment';
import { useState } from 'react';
import { Modal } from '../../Modal';
import getPPVDetails from './getPPVDetails';
import { ProgramCard } from '../../ProgramCard';
import { isFutureProgram } from '../isFutureProgram';

type IProgramDetailModal = {
    isOpen: boolean;
    onOpenChange: (isOpen?: boolean) => void;
    selectedProgram: any;
    modalContent: any;
    ppvEventConfig: any;
    onPPVPurchaseClick: ((eventId: string) => void) | undefined;
    initialIsFavorite: boolean;
    onFavoriteClick: (e: any) => void;
    removeFavoriteButtonLabel: string;
    favoriteButtonLabel: string;
    AddReminderButton: any;
    AddWatchListButton: any;
    beforeTag: string;
    afterTag: string;
    liveTag: string;
    lang?: string;
};

// TODO: no need for separate Modal component?
const ProgramDetailsModal = ({
    isOpen,
    onOpenChange,
    onPPVPurchaseClick,
    selectedProgram,
    modalContent,
    initialIsFavorite,
    onFavoriteClick,
    ppvEventConfig,
    removeFavoriteButtonLabel,
    favoriteButtonLabel,
    AddReminderButton,
    AddWatchListButton,
    lang,
    beforeTag,
    afterTag,
    liveTag,
}: IProgramDetailModal) => {
    const [isFavorite, setIsFavorite] = useState(initialIsFavorite);

    const handleFavoriteClick = (channelId: string) => {
        onFavoriteClick(channelId);
        setIsFavorite((prev: boolean) => !prev);
    };

    const { isPPV, isPPVPurchased, ppvEventId, ppvPrice, ppvCurrency } = getPPVDetails(
        modalContent,
        selectedProgram,
        ppvEventConfig
    );

    if (!modalContent) {
        return null;
    }

    return (
        <Modal open={isOpen} onOpenChange={onOpenChange} alignSelf="bottom" closePlacement="null">
            <ProgramCard
                addToFavoriteButton={{
                    isActive: true,
                    onClick: () => {
                        if (modalContent?.channel?.channelID) {
                            handleFavoriteClick(modalContent.channel.channelID);
                        }
                    },
                    text: isFavorite ? removeFavoriteButtonLabel : favoriteButtonLabel,
                }}
                addWatchListButton={
                    isFutureProgram(modalContent?.startTime, modalContent?.endTime) ? (
                        <AddReminderButton
                            item={modalContent}
                            index={modalContent.index}
                            isComingSoon
                            category="LINEAR"
                            selectedChannel={modalContent.channel}
                            secondary
                        />
                    ) : (
                        <AddWatchListButton
                            item={{
                                Id: modalContent.id,
                                paId: modalContent.paId,
                                programType: modalContent.programType,
                                category: 'linear',
                            }}
                            type="ProgramItem"
                            watchlistButton
                        />
                    )
                }
                channelName={lang === 'en' ? modalContent?.title : modalContent?.localizedTitle?.ar}
                channelNumber={modalContent?.channel?.channelNumber}
                description={lang === 'en' ? modalContent?.description : modalContent?.localizedDescription?.ar}
                duration={`${moment(modalContent?.since).format('MMM DD HH:mm')} - ${moment(modalContent?.till).format(
                    'MMM DD HH:mm'
                )}`}
                isLive={modalContent?.isLive}
                isBefore={!modalContent?.isLive && !isFutureProgram(modalContent?.startTime, modalContent?.endTime)}
                isAfter={!modalContent?.isLive && isFutureProgram(modalContent?.startTime, modalContent?.endTime)}
                beforeTag={beforeTag}
                afterTag={afterTag}
                liveTag={liveTag}
                // PPV props
                isPPV={isPPV}
                isPPVPurchased={isPPVPurchased}
                ppvEventId={ppvEventId}
                ppvPrice={ppvPrice}
                ppvCurrency={ppvCurrency}
                onPPVPurchaseClick={onPPVPurchaseClick}
            />
        </Modal>
    );
};

export default ProgramDetailsModal;
